import { reviewQueryKeys as e } from "./useReviewQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { reviewsApi as n } from "@maat/api-booking";
//#region src/reviews/useUnansweredReviewsQuery.ts
var r = (r) => t({
	queryKey: e.workspaceUnanswered(),
	queryFn: () => n.listWorkspaceReviews({
		limit: r?.limit ?? 5,
		has_host_reply: !1
	}),
	enabled: r?.enabled ?? !0
});
//#endregion
export { r as useUnansweredReviewsQuery };
